import { useEffect, useState } from 'react';
import { adminUsersApi, examAuthoringApi } from '../lib/api';
import { useAuth } from '../auth/AuthContext';

const ROLES = ['learner', 'member', 'instructor', 'assistant', 'tenant_admin'];

/** Comptes du tenant : création, rôles, révocation de sessions. */
export function UsersAdminPage() {
  const { principal } = useAuth();
  const [users, setUsers] = useState<any[]>([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('learner');
  const [cases, setCases] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  useEffect(() => { reload(); }, [principal?.tenant_id]);

  async function reload() {
    if (!principal?.tenant_id) return;
    try { setUsers(await adminUsersApi.users(principal.tenant_id)); }
    catch (e: any) { setError(String(e.message || e)); }
    try { setCases(await examAuthoringApi.incubationCases()); } catch { /* facultatif */ }
  }

  async function run(fn: () => Promise<any>, note: string) {
    setError(''); setNotice('');
    try { await fn(); setNotice(note); await reload(); }
    catch (e: any) { setError(String(e.message || e)); }
  }

  return <section className="page">
    <header className="page-header">
      <div>
        <span className="eyebrow">COMPTES</span>
        <h1>Utilisateurs du tenant</h1>
        <p>Un rôle privilégié ne peut être attribué que par un administrateur authentifié.</p>
      </div>
      <span className="status ok">{users.length} compte(s)</span>
    </header>

    {error && <div className="alert error">{error}</div>}
    {notice && <div className="notice">{notice}</div>}

    <div className="grid two">
      <div className="card">
        <h3>Créer un compte</h3>
        <label>Email<input type="email" value={email} onChange={(e: any) => setEmail(e.target.value)} /></label>
        <label>Mot de passe provisoire<input type="password" value={password} onChange={(e: any) => setPassword(e.target.value)} minLength={8} /></label>
        <label>Rôle
          <select value={role} onChange={(e: any) => setRole(e.target.value)}>
            {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </label>
        <p className="technical-note">
          Le rôle platform_admin ne s'attribue pas ici : il passe uniquement par
          scripts/create_admin.py, sur le serveur.
        </p>
        <button className="button primary" disabled={!email.trim() || password.length < 8}
          onClick={() => run(() => adminUsersApi.createUser({
            email: email.trim(), password, tenant_id: principal?.tenant_id, role,
          }), 'Compte créé.')}>Créer</button>
      </div>

      <div className="card">
        <h3>Comptes existants</h3>
        {users.map(u => <div key={u.id} className="order-row">
          <strong>{u.email}</strong>
          <span>{u.role} · {u.id.slice(0, 8)}</span>
          <button className="button secondary" onClick={() =>
            run(() => adminUsersApi.revokeSessions(u.id), 'Sessions révoquées.')}>
            Révoquer ses sessions
          </button>
        </div>)}
        {!users.length && <p className="technical-note">Aucun compte listé.</p>}
      </div>
    </div>

    {cases.length > 0 && <div className="card">
      <h3>Dossiers d'incubation ({cases.length})</h3>
      {cases.slice(0, 15).map(c => <div key={c.id} className="order-row">
        <strong>{c.title}</strong><span>{c.status}</span>
      </div>)}
    </div>}
  </section>;
}
